

export const REPORT_GRID_STYLE = {
  borderColor: 'transparent',
  bgColor: 'transparent',
  borderWidth: 8,
};

/*
 * Because Grid Row heights are hardcoded, and the amount that comes back in a report
 * are dynamic, we'll need to find the largest (tallest) grouping in order to size
 * everything correctly. The max currently (based on report limits) is 10.
 *
 * These utilities will help calculate this. findMaxItems allows for the passing of
 * either plain multi-dimensional arrays [[], [], [], []], or an arrays of objects, with
 * with a specific key in mind for the sub array (such as top_keywords_by_entity[0].resources)
 */
export const ROW_HEIGHT_BASE_MAP = {
  content: 130,
  entity: 140,
  keyword: 140,
  social: 120,
  error: {
    content: 280, // Accounts for base + error text / 4 cols
    entity: 140,
    keyword: 140,
    social: 260,
  },
};

export const findMaxItems = (resources, key) => resources.reduce((acc, curr) => {
  if (key) {
    return curr[key].length > acc ? curr[key].length : acc;
  }
  return curr.length > acc ? curr.length : acc;
}, 0);

export const calculateRowHeight = (max, type) => {
  if (max === 0) {
    /* Error states */
    return ROW_HEIGHT_BASE_MAP.error[type] + 350; // 350 = 7 dummy items * 50 height
  }
  return ROW_HEIGHT_BASE_MAP[type] + (50 * max); // 50 = height of entity items/horizontal rows
};
